import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './calendar-item.types';
import * as constants from './calendar-item.constants';

export const storeCalendarItem = generateStoreResourceAction<types.ICalendarItem>(constants.STORE_CALENDAR_ITEM);
export const clearCalendarItem = generateClearResourceAction(constants.CLEAR_CALENDAR_ITEM);
